import 'bootstrap-maxlength';
frappe.ready(()=>{
	if (frappe.ui.form.ControlData) {
		frappe.ui.form.ControlText = frappe.ui.form.ControlData.extend({
			html_element: "textarea",
			horizontal: false,
			make_wrapper: function () {
				this._super();
				this.$wrapper.find(".like-disabled-input").addClass("for-description");
			},
			make_input: function () {
				this._super();
				this.$input.css({'height': '300px'});
				if (this.df.max_length && this.df.max_length > 0) {
					this.$input.maxlength({
						customMaxAttribute: this.df.max_length.toString(),
						showOnReady: false,
						validate: true
					});
				}
			},
			set_invalid: function () {
				if (this.$input)
					this.df.invalid = this.$input.hasClass('overmax');
				this._super();
			}
		});

		frappe.ui.form.ControlLongText = frappe.ui.form.ControlText;
		frappe.ui.form.ControlSmallText = frappe.ui.form.ControlText.extend({
			make_input: function () {
				this._super();
				this.$input.css({'height': '150px'});
			}
		});
	}
})